const decreaseSvg = `
<svg width="19" height="6" viewBox="0 0 19 6" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.08403 5.17246H3.70472C2.62465 5.17246 2.04847 4.87323 1.73251 4.5201C1.40708 4.15638 1.27368 3.64274 1.27368 3.05177C1.27368 2.4158 1.40302 1.87589 1.72681 1.49759C2.03778 1.13429 2.60893 0.827637 3.70472 0.827637H7.08403H12.4633H15.8082C16.8842 0.827637 17.4702 1.13317 17.7965 1.50034C18.1329 1.8788 18.2737 2.41194 18.2737 3.01729C18.2737 3.60285 18.1341 4.12751 17.7979 4.50248C17.4712 4.86689 16.8842 5.17246 15.8082 5.17246H12.4633H12.4564H12.4495H12.4425H12.4355H12.4285H12.4214H12.4142H12.407H12.3998H12.3926H12.3853H12.3779H12.3705H12.3631H12.3556H12.3481H12.3406H12.333H12.3254H12.3177H12.31H12.3023H12.2945H12.2867H12.2789H12.271H12.263H12.2551H12.2471H12.239H12.2309H12.2228H12.2147H12.2065H12.1982H12.19H12.1817H12.1733H12.165H12.1566H12.1481H12.1396H12.1311H12.1226H12.114H12.1054H12.0967H12.088H12.0793H12.0705H12.0617H12.0529H12.0441H12.0352H12.0262H12.0173H12.0083H11.9993H11.9902H11.9811H11.972H11.9628H11.9537H11.9444H11.9352H11.9259H11.9166H11.9072H11.8979H11.8885H11.8696H11.8601H11.8505H11.841H11.8314H11.8218H11.8121H11.8024H11.7927H11.783H11.7732H11.7634H11.7536H11.7438H11.7339H11.724H11.714H11.7041H11.6941H11.6841H11.674H11.6639H11.6538H11.6437H11.6336H11.6234H11.6132H11.6029H11.5927H11.5824H11.5721H11.5618H11.5514H11.541H11.5306H11.5202H11.5097H11.4992H11.4887H11.4782H11.4676H11.4571H11.4464H11.4358H11.4252H11.4145H11.4038H11.3931H11.3823H11.3716H11.3608H11.35H11.3391H11.3283H11.3174H11.3065H11.2956H11.2847H11.2737H11.2627H11.2517H11.2407H11.2296H11.2186H11.2075H11.1964H11.1853H11.1741H11.163H11.1518H11.1406H11.1294H11.1181H11.1069H11.0956H11.0843H11.073H11.0617H11.0503H11.0389H11.0276H11.0162H11.0048H10.9933H10.9819H10.9704H10.9589H10.9474H10.9359H10.9244H10.9128H10.9013H10.8897H10.8781H10.8665H10.8549H10.8432H10.8316H10.8199H10.8082H10.7965H10.7848H10.7731H10.7613H10.7496H10.7378H10.726H10.7143H10.7025H10.6906H10.6788H10.667H10.6551H10.6432H10.6314H10.6195H10.6076H10.5957H10.5837H10.5718H10.5599H10.5479H10.5359H10.524H10.512H10.5H10.488H10.476H10.4639H10.4519H10.4399H10.4278H10.4157H10.4037H10.3916H10.3795H10.3674H10.3553H10.3432H10.3311H10.3189H10.3068H10.2947H10.2825H10.2703H10.2582H10.246H10.2338H10.2217H10.2095H10.1973H10.1851H10.1729H10.1606H10.1484H10.1362H10.124H10.1118H10.0995H10.0873H10.075H10.0628H10.0505H10.0383H10.026H10.0137H10.0015H9.9892H9.97693H9.96465H9.95237H9.94009H9.92781H9.91552H9.90323H9.89094H9.87865H9.86635H9.85406H9.84176H9.82947H9.81717H9.80487H9.79257H9.78027H9.76797H9.75567H9.74337H9.73107H9.71877H9.70648H9.69418H9.68188H9.66959H9.65729H9.645H9.63271H9.62042H9.60813H9.59585H9.58356H9.57128H9.55901H9.54673H9.53446H9.52219H9.50992H9.49766H9.4854H9.47315H9.46089H9.44865H9.4364H9.42417H9.41193H9.3997H9.38748H9.37526H9.36304H9.35083H9.33863H9.32643H9.31424H9.30206H9.28988H9.2777H9.26554H9.25338H9.24122H9.22908H9.21694H9.20481H9.19268H9.18057H9.16846H9.15636H9.14427H9.13218H9.12011H9.10804H9.09598H9.08393H9.07189H9.05986H9.04784H9.03583H9.02383H9.01184H8.99986H8.98789H8.97592H8.96397H8.95203H8.94011H8.92819H8.91628H8.90439H8.89251H8.88064H8.86878H8.85693H8.8451H8.83327H8.82146H8.80967H8.79788H8.78611H8.77435H8.76261H8.75088H8.73916H8.72746H8.71577H8.7041H8.69244H8.68079H8.66916H8.65754H8.64594H8.63436H8.62279H8.61123H8.59969H8.58817H8.57666H8.56517H8.5537H8.54224H8.5308H8.51938H8.50797H8.49658H8.48521H8.47385H8.46251H8.45119H8.43989H8.42861H8.41734H8.4061H8.39487H8.38366H8.37247H8.3613H8.35015H8.33902H8.3279H8.31681H8.30574H8.29469H8.28366H8.27264H8.26165H8.25068H8.23973H8.22881H8.2179H8.20701H8.19615H8.18531H8.17449H8.16369H8.15292H8.14216H8.13143H8.12072H8.11004H8.09938H8.08874H8.07813H8.06753H8.05697H8.04642H8.0359H8.02541H8.01494H8.00449H7.99407H7.98368H7.9733H7.96296H7.95264H7.94234H7.93207H7.92183H7.91161H7.90142H7.89126H7.88112H7.87101H7.86092H7.85086H7.84083H7.83083H7.82086H7.81091H7.80099H7.7911H7.78123H7.7714H7.76159H7.75181H7.74206H7.73234H7.72265H7.71299H7.70336H7.69376H7.68418H7.67464H7.66513H7.65565H7.64619H7.63677H7.62738H7.61802H7.6087H7.5994H7.59014H7.5809H7.5717H7.56253H7.55339H7.54429H7.53521H7.52618H7.51717H7.50819H7.49925H7.49034H7.48147H7.47263H7.46382H7.45505H7.44631H7.4376H7.42893H7.4203H7.4117H7.40313H7.3946H7.38611H7.37764H7.36922H7.36083H7.35248H7.34416H7.33588H7.32764H7.31943H7.31126H7.30312H7.29503H7.28697H7.27894H7.27096H7.26301H7.2551H7.24723H7.2394H7.2316H7.22385H7.21613H7.20845H7.20081H7.19321H7.18565H7.17813H7.17065H7.16321H7.15581H7.14844H7.14112H7.13384H7.1266H7.1194H7.11225H7.10513H7.09805H7.09102H7.08403Z" fill="#001C3D" stroke="white"/>
</svg>`;

const increaseSvg = `
<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.4736 6.91369L15.8132 6.84483C16.8861 6.84578 17.4707 7.15094 17.7965 7.51753C18.1329 7.89599 18.2737 8.42914 18.2737 9.03448C18.2737 9.62004 18.1341 10.1447 17.7979 10.5197C17.4718 10.8835 16.886 11.1887 15.8132 11.1897L12.4736 11.1208L11.9529 11.1101L11.9634 11.6308L12.0323 15.0394C12.0313 16.1084 11.72 16.6917 11.3428 17.0187C10.9513 17.358 10.3989 17.5 9.77368 17.5C9.14843 17.5 8.59611 17.358 8.2046 17.0187C7.82732 16.6917 7.51602 16.1084 7.51506 15.0394L7.58392 11.6308L7.59444 11.1102L7.07382 11.1208L3.69971 11.1897C2.62287 11.1887 2.04798 10.8899 1.73251 10.5373C1.40708 10.1736 1.27368 9.65993 1.27368 9.06896C1.27368 8.43299 1.40302 7.89308 1.72681 7.51479C2.03731 7.15203 2.60719 6.84576 3.69971 6.84483L7.07382 6.91369L7.59423 6.92431L7.58393 6.4039L7.51506 2.9262C7.51598 1.85316 7.82098 1.28075 8.18687 0.964474C8.56725 0.635665 9.10867 0.5 9.7392 0.5C10.3947 0.5 10.9539 0.63025 11.3455 0.957127C11.719 1.26887 12.0314 1.83756 12.0323 2.9262L11.9634 6.4039L11.9531 6.92442L12.4736 6.91369Z" fill="#001C3D" stroke="white"/>
</svg>`;

function moveByob() {
  $('#byobApp').appendTo('.product-byob__flavors');
  $('.byob-footer').insertAfter('.product-form__buttons');
  if (!$('input[name="selling_plan"]').val()) {
    $('input[name="selling_plan"]').val($('#bsub__frequency').val());
  }
}

function addButtonToGridProduct() {
  $('.byob-accordion-container .grid-product').each(function () {
    if (!$(this).find('.decrease-bundle').length) {
      $(this).append(`
          <div class="bundle-actions">
            <button class="decrease-bundle">
              ${decreaseSvg}
            </button>
            <span class="count">0</span>
            <button class="increase-bundle">
              ${increaseSvg}
            </button>
          </div>
        `);
    }
  });
}

function onAddToBundle() {
  let bundleVariants = window.sessionStorage.getItem(`bundle${window.buildrule.bundle}_selectedVariants`);
  if (bundleVariants) {
    bundleVariants = JSON.parse(bundleVariants);
    $('.byob-badge').remove();

    let variantCounts = {};
    bundleVariants.forEach((variant) => {
      const cleanVariantName = variant.name.replace(/\s-\s.*$/, '');
      const byobItem = $(`.byob-product-image-container img[alt="${cleanVariantName}"]`);

      if (byobItem.length) {
        variantCounts[cleanVariantName] = (variantCounts[cleanVariantName] || 0) + 1;
      }
    });

    $('.grid-product').each(function () {
      $(this).find('.count').text('0');
      $(this).find('.byob-badge').remove();
    });

    for (const [name, count] of Object.entries(variantCounts)) {
      const byobItem = $(`.byob-product-image-container img[alt="${name}"]`);
      const gridProduct = byobItem.closest('.grid-product');

      if (byobItem.length) {
        byobItem.before(`<div class="byob-badge">${count}</div>`);
        gridProduct.find('span.count').text(count);
      }
    }
  }

  remainingQuantity();
}

function onDecreaseToBundle() {
  let bundleVariants = window.sessionStorage.getItem(`bundle${window.buildrule.bundle}_selectedVariants`);
  if (bundleVariants) {
    bundleVariants = JSON.parse(bundleVariants);

    bundleVariants.forEach((variant) => {
      const cleanVariantName = variant.name.replace(/\s-\s.*$/, '');
      const byobItem = $(`.byob-product-image-container img[alt="${cleanVariantName}"]`);

      if (byobItem.length) {
        const variantId = variant.id;
        const button = byobItem.closest('.grid-product').find('.decrease-bundle');
        if (button.length) {
          button.attr('data-variant-id', variantId);
        }
      }
    });
  }

  remainingQuantity();
}

$(document).ready(() => {
  moveByob();
  addButtonToGridProduct();
  onAddToBundle();
  onDecreaseToBundle();
});

$(window).on('load', () => {
  moveByob();
  addButtonToGridProduct();
  onAddToBundle();
  onDecreaseToBundle();
});

$(document).on('click', '.btn-add-to-bundle', () => setTimeout(moveByob, 50));
$(document).on('click', '.AddToBundleText, .byob-close', () => setTimeout(onAddToBundle, 100));
$(document).on('click', '.increase-bundle', function () {
  const addToBundleButton = $(this).closest('.grid-product').find('.AddToBundleText');
  const checkDisabled = $(this).closest('.grid-product').find('.btn-add-to-bundle');

  if (!checkDisabled.prop('disabled')) {
    addToBundleButton.click();
  }
});

$(document).on('click', '.decrease-bundle', function () {
  const variantId = $(this).attr('data-variant-id');
  if (variantId) {
    const removeIcon = $(`#byob-remove-icon-${variantId}`);
    if (removeIcon.length) {
      removeIcon[0].click();
    }
  }
});

$(document).on('click', '.AddToBundleText', () => setTimeout(onDecreaseToBundle, 100));

Element.prototype.scrollIntoView = function () {
  return false;
};

$(document).ready(() => {
  $('.grid-product').each(function () {
    const img = $(this).find('.byob-product-image-container img');
    if (img.length) {
      let productName = img.attr('alt').trim().split(' ')[0];
      let className = `pc-${productName.toLowerCase()}`;
      className = className.replace(/[^a-z0-9-]/g, '');
      $(this).addClass(className);
    }
  });
});

function remainingQuantity() {
  const quantity = buildrule.quantity;
  const remaining = buildrule.remaining_quantity;

  if (remaining < quantity && remaining > 0) {
    $('#add-to-cart-byob2').addClass('sold-out');
    $('#add-to-cart-byob2 span').text(`Add ${remaining} more flavor${remaining > 1 ? 's' : ''}`);
  } else if (remaining == quantity) {
    $('#add-to-cart-byob2').addClass('sold-out');
    $('#add-to-cart-byob2 span').text(`Add ${quantity} more flavor${quantity > 1 ? 's' : ''}`);
  } else {
    $('#add-to-cart-byob2').removeClass('sold-out');
    $('#add-to-cart-byob2 span').text(`Add to Cart`);
  }

  if ($('#add-to-cart-byob2').is(':hidden')) {
    $('#add-to-cart-byob2').show();
  }
}

$(document).ready(() => {
  remainingQuantity();
});

$(document).on('click', '#add-to-cart-byob2', function (e) {
  e.preventDefault();

  $(this).addClass('loading');

  const remaining = buildrule.remaining_quantity;

  if (remaining) {
    alert(`Please choose ${remaining} more product${remaining > 1 ? 's' : ''}.`);
    $(this).removeClass('loading');
    return false;
  }

  let bundleVariants = window.sessionStorage.getItem(`bundle${window.buildrule.bundle}_selectedVariants`);
  if (bundleVariants) {
    bundleVariants = JSON.parse(bundleVariants);

    sellingPlan = $('input[data-state="onetime"]').prop('checked') ? false : $('input[name="selling_plan"]').val();
    const quantity = $('#Quantity').val() || 1;
    const data = { items: [] };

    let discountBase = 'BYOB12';
    if (window.location.pathname.includes('box-9-pack')) {
      discountBase = 'BYOB9';
    } else if (window.location.pathname.includes('box-6-pack') && sellingPlan) {
      discountBase = 'BYOB6';
    }

    let discountCode = sellingPlan ? discountBase : `${discountBase}SINGLE`;

    if (window.location.pathname.includes('box-6-pack') && !sellingPlan) {
      discountCode = 'BYOB6SINGLE';
    }

    bundleVariants.forEach((variant) => {
      sellingPlanId = null;

      if (sellingPlan) {
        const byobCount = parseInt(window.location.pathname.match(/\d+/)[0], 10);
        const byobProducts = JSON.parse($('#byob-products').text());
        const selectedFrequency = $('#bsub__frequency').val();

        const parentProduct = byobProducts.find((prod) => prod.id === variant.productID);

        sellingPlanId =
          parentProduct.selling_plan_groups
            .find((group) => group.name === `BYOB 1-Pack`)
            ?.selling_plans.find((plan) => plan.name === selectedFrequency)?.id || null;
      }

      data.items.push({
        id: variant.id,
        quantity: quantity,
        selling_plan: sellingPlanId,
      });
    });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            discount: discountCode,
          }),
        })
          .then((response) => response.json())
          .then((updatedCart) => {
            openCartDrawer(updatedCart);
          })
          .catch((error) => {
            openCartDrawer(cart);
          });
      })
      .catch((error) => {
        console.error(error);
        $('#add-to-cart-byob2').removeClass('loading');
      });
  }
});

/**
 * When changing subscription selection
 */
const mainselector = $('.bsub-widget__group input[name="byob-subs"]');

mainselector.on('change', function () {
  $('.bsub-widget__group').removeClass('active');

  if ($(this).is(':checked')) {
    $(this).closest('.bsub-widget__group').addClass('active');
  }
});

mainselector.each(function () {
  if ($(this).is(':checked')) {
    $(this).closest('.bsub-widget__group').addClass('active');
  }
});

$('#bsub__frequency').on('change', function () {
  $('.appstle_subscribe_option_texts .days').text($(this).val());
});

$(document).on('click', '.pdpfaq-inner-content-list-item p', function () {
  let $parent = $(this).parent();

  if ($parent.hasClass('active')) {
    $parent.removeClass('active').find('.answer').slideUp(200);
    return;
  }

  $('.pdpfaq-inner-content-list-item.active').removeClass('active').find('.answer').slideUp(200);

  $parent.addClass('active');
  $(this).next('.answer').slideDown(200);
});

$(document).on('click', '.accordion-item p', function () {
  let $parent = $(this).parent();

  if ($parent.hasClass('active')) {
    $parent.removeClass('active').find('.accordion-item-content').slideUp(200);
    return;
  }

  $('.accordion-item.active').removeClass('active').find('.accordion-item-content').slideUp(200);

  $parent.addClass('active');
  $(this).next('.accordion-item-content').slideDown(200);
});
function openCartDrawer(cartData) {
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) {
    updateCartDrawer(cartData).then(() => {
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('drawer__open');
      document.documentElement.classList.add('no-scroll');
    });
  } else {
    let cartUrl = window.location.origin + window.Shopify.routes.root + 'cart/';
    const cartParams = new URLSearchParams({
      ref: `BYOB${window.buildrule.bundle}`,
      'attributes[where-from]': 'BYOB-',
      'attributes[byob_bundle_id]': window.buildrule.bundle,
      storefront: true,
    });
    cartUrl += '?' + cartParams;
    window.location.href = cartUrl;
  }
}
function updateCartDrawer(cartData) {
  return new Promise((resolve, reject) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      fetch('/cart?section_id=cart-drawer')
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartDrawer = doc.querySelector('cart-drawer');

          if (newCartDrawer && cartDrawer) {
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
          resolve();
        })
        .catch((error) => {
          console.error('Error updating cart drawer:', error);
          reject(error);
        });
    } else {
      resolve();
    }
  });
}
